import UserContext from "../../../../context/user/UserContext";
import React, { useState, useContext } from "react";
import { useDropzone } from "react-dropzone";
import styled, { useTheme } from "styled-components";
import { Heading } from "../../Text";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Flex } from "reflexbox";
import Loading from "../../Loading";
import Modal from "../../Modal";
import ImageCropper from "../ImageCropper";
import { useFormikContext, Formik } from "formik";

const DropTarget = styled(Flex)`
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
  padding: 1rem;
  width: 100%;
  border: dashed 2px ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => `${theme.borderRadius}px`};
  position: relative;
  div {
    margin: 0;
  }
  svg {
    margin-left: 1rem;
    width: 70px;
    height: auto;
  }
  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const processUpload = async (
  file,
  path = "/api/uploadfile",
  id,
  query
) => {
  const formData = new FormData();
  formData.append("file", file);
  if (query) {
    for (const [k, v] of Object.entries(query)) {
      formData.append(k, v);
    }
  }
  if (id) formData.append("id", id);

  const uploadedFile = await axios.post(path, formData, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });

  return uploadedFile;
};

// const checkFileType = (filetype) => {
//   if (filetype === "video") {
//     return "video/mp4,video/x-m4v,video/*";
//   }
//   if (filetype === "officedoc") {
//     return `application/msword,  application/vnd.ms-excel,
//       application/vnd.ms-powerpoint,
//       application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
//       application/vnd.openxmlformats-officedocument.presentationml.presentation,
//       application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
//   }
//   if (filetype === "pdf") {
//     return "application/pdf";
//   }
//   return "image/*";
// };

const FileInput = ({
  multiple = false,
  onSubmit,
  labelText,
  path,
  disabled,
  isImage,
  id,
  preUploadCallback,
  postUploadCallback,
  query,
}) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);

  // console.log(values);

  // const accept = checkFileType(filetype);
  const headerText = multiple ? "Files" : "a File";

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: disabled
      ? () => {}
      : (files) => {
          files.forEach(async (file) => {
            if (!!preUploadCallback) preUploadCallback(file);
            setIsLoading(true);
            const response = await processUpload(file, path, id, query);
            onSubmit(file);
            setIsLoading(false);
            if (!!postUploadCallback) postUploadCallback(response);
          });
        },
    multiple,
  });

  return (
    <>
      {isImage ? (
        <Modal show={show} setShow={setShow}>
          <ImageCropper />
        </Modal>
      ) : null}
      <Flex width={1} {...getRootProps()}>
        {disabled || isLoading ? null : <input {...getInputProps()} />}
        <DropTarget>
          <Heading>
            {isLoading ? "Uploading..." : labelText || `Upload ${headerText}`}
          </Heading>
          {isLoading ? (
            <Loading relative />
          ) : (
            <FontAwesomeIcon color={theme.secondary} icon={faCloudArrowUp} />
          )}
        </DropTarget>
      </Flex>
    </>
  );
};

export default FileInput;
